import AutocaptureConfig from "../../../../contents/docs/libraries/react-native/_snippets/autocapture-config-rn.mdx";
import * as React from 'react';
export default {
  AutocaptureConfig,
  React
};